<div class="first">
  <button class="menu" mat-icon-button (click)="toggleMenu()">
    <mat-icon>menu</mat-icon>
  </button>
  <h1><a routerLink="/">پـرتـال کاربـری برندشو</a></h1>
</div>

<div class="second">
  <button mat-icon-button style="margin-left: 10px;">
    <mat-icon style="color: white;">notifications</mat-icon>
  </button>
  <button class="user-indicator" mat-button [matMenuTriggerFor]="navMenu">
    <span class="fa fa-ellipsis-v"></span>
    <span class="name">{{fullName}}</span>
  </button>
  <mat-menu #navMenu="matMenu">
    <button mat-menu-item routerLink="/profile">
      <span class="menu-icon fa fa-user"></span>
      <span>پروفایل من</span>
    </button>
    <button mat-menu-item (click)="onLogout()">
      <span class="menu-icon fa fa-sign-out"></span>
      <span>خارج شدن</span>
    </button>
  </mat-menu>
</div>
